// extracted by mini-css-extract-plugin
module.exports = {"action":"styles_action__1ec8j","add":"styles_add__CHm4q","actions":"styles_actions__1XL6k","delete":"styles_delete__2PLlH"};